import { deepEqual } from "../../utils/deep-equal";

export class Stack<T = null> {
  constructor() {}

  public stack: Array<T> = [];
  private _currentState: T | null = null;
  private _forwardState: T | null = null;
  private _previousState: T | null = null;

  public get currentState() {
    return this._currentState;
  }

  public get previousState() {
    return this._previousState;
  }

  public get forwardState() {
    return this._forwardState;
  }

  public forward() {
    const currentIndex = this.stack.findIndex(item =>  deepEqual(item, this._currentState));
    this._previousState = this._currentState;
    this._currentState = this._forwardState;
    this._forwardState = this.stack[currentIndex + 1] || null;
  }

  public back() {
    const currentIndex = this.stack.findIndex(item =>  deepEqual(item, this._currentState));
    this._forwardState = this._currentState;
    this._currentState = this._previousState;
    this._previousState = this.stack[currentIndex - 1] || null;
  }

  public push(state: T) {
    const currentIndex = this.stack.findIndex(item =>  deepEqual(item, this._currentState));
    this.stack.length = currentIndex + 1;
    this.stack.push(state);
    this._previousState = this._currentState;
    this._forwardState = null;
    this._currentState = state;
  } 

  public popstate(state: T) {
    const currentIndex = this.stack.findIndex(item =>  deepEqual(item, this._currentState));
    const newIndex = this.stack.findIndex(item =>  deepEqual(item, state));
    if (newIndex > currentIndex) this._previousState = this._currentState;
    if (newIndex < currentIndex) this._forwardState = this._currentState;
    this._currentState = state;
  }

  public replace(state: T) {
    const currentIndex = this.stack.findIndex(item =>  deepEqual(item, this._currentState));
    this.stack[currentIndex] = state;
    this._currentState = state;
  }
}